import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SuggestedUserEffects } from './suggested-user.effects';
import { suggestedUsersReducer } from './suggested-user.reducer';

export const provideSuggestedUserStore = () => [
  provideState('suggested-users', suggestedUsersReducer),
  provideEffects([SuggestedUserEffects]),
];
